import React, { useEffect } from "react";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { Outlet, useLocation } from "react-router";

import Notify from "./modules/common/Notify";
import GlobalErrorAlert from "./modules/GlobalErrorAlert";
import { UserContextProvider } from "./store";
import theme from "./theme";
import { trackPageView } from "./analytics";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
    },
  },
});

function App() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <QueryClientProvider client={queryClient}>
        <UserContextProvider>
          <div className="App">
            <Notify />
            <Outlet />
            <GlobalErrorAlert />
          </div>
        </UserContextProvider>
      </QueryClientProvider>
    </ThemeProvider>
  );
}

export default App;
